import { api } from './api';

// Slack OAuth - Organization Level
export const getSlackAuthUrl = async (orgId) => {
  const response = await api.get(`/slack/${orgId}/auth-url`);
  return response.data;
};

export const getSlackStatus = async (orgId) => {
  const response = await api.get(`/slack/${orgId}/status`);
  return response.data;
};

export const getSlackChannels = async (orgId) => {
  const response = await api.get(`/slack/${orgId}/channels`);
  return response.data;
};

export const disconnectSlack = async (orgId) => {
  const response = await api.delete(`/slack/${orgId}/disconnect`);
  return response.data;
};

export const testSlackNotification = async (orgId, channelId) => {
  const response = await api.post(`/slack/${orgId}/test`, { channelId });
  return response.data;
};

// Team Slack Settings
export const getTeamSlackSettings = async (teamId) => {
  const response = await api.get(`/teams/${teamId}/slack-settings`);
  return response.data;
};

export const updateTeamSlackSettings = async (teamId, settings) => {
  const response = await api.put(`/teams/${teamId}/slack-settings`, settings);
  return response.data;
};

const slackApi = {
  getSlackAuthUrl,
  getSlackStatus,
  getSlackChannels,
  disconnectSlack,
  testSlackNotification,
  getTeamSlackSettings,
  updateTeamSlackSettings,
};

export default slackApi;
